export const FILTER_LABELS = {
  type1: 'Tipos',
  type2: 'Ocasiões',
  difficulty: 'Dificuldade',
};
